// The project's cultural calendar (V4StudioCalendar).
export default {
  titre: 'Cultural calendar & opportunities',
  erreur: {
    illisible: 'Could not load the calendar',
    generation: 'Could not generate',
    selection: 'Selection not saved',
    deMarque: '{marque}: {message}',
  },
  reco: {
    priorite: 'PRIORITY',
    considerer: 'CONSIDER',
    radar: 'RADAR',
  },
  audience: {
    coeur: 'CORE',
    adjacent: 'ADJACENT',
    hors_cible: 'OFF TARGET',
  },
  date: {
    confirme: 'Confirmed',
    fenetre: 'Window',
    tbc: 'TBC',
  },
  format: {
    shorts: 'Shorts flow',
    post: 'Post',
    visuel: 'Visual',
    sondage: 'Poll',
    veille: 'Monitoring',
  },
  case: {
    deMarque: '{marque}: {texte}',
    evenement: '{nom} - {etat}',
  },
  milestone: 'internal milestone',
  milestoneTitre: 'Internal milestone',
  sousTitre: {
    genere: 'generated on {date}',
    marques: '{n} brands',
  },
  seule: {
    aide: 'Generated from the audit of {date}: personas, territories and audience crossroads. No invented events: public cultural recurrences matched against your signals. TBC dates to be re-checked at D-60.',
    depuis: 'generated from the audit of {date}',
    aideGenerer: 'Generates the brand’s editorial calendar',
    generation: 'Generating…',
    regenerer: 'Regenerate',
    generer: 'Generate the calendar',
    recommande: 'recommended after each audit / quarter',
  },
  plusieurs: {
    aide: 'Generated from the audit of {date}: the brand’s personas, territories and audience crossroads. TBC dates to be re-checked at D-60.',
    evenements: '{n} events | {n} event | {n} events',
    genere: '· generated on {date}',
    depuis: 'from the audit of {date}',
    pasEncore: 'no calendar yet: it is generated at the brand’s audit',
    aideGenerer: 'Generates the editorial calendar of {marque}, from its personas and territories',
    generer: 'Generate',
  },
  vide: {
    aucunDossier: 'No project open',
    aucunDossierTexte: 'The calendar belongs to a project: it brings together the calendars of all its brands. Choose a project in the left sidebar.',
    chargement: 'Loading the calendar…',
    aucuneMarque: 'No brands in this project',
    aucuneMarqueTexte: 'The calendar brings together those of the project’s brands: create one, and its first audit will generate its own.',
    croisement: 'Matching personas × territories × culture, ~30 s…',
    aucunCalendrierDossier: 'No calendar for this project',
    aucunCalendrierMarque: 'No calendar for this brand',
    croise: 'The calendar matches your personas, the detected territory and the audience crossroads against the cultural recurrences of the next 12 months.',
    chaqueMarque: 'Each brand gets its own at its audit; they are brought together here.',
    lancez: 'Run a full audit first, then generate.',
  },
  vue: {
    master: 'Master',
    grille: 'Grid',
  },
  filtre: {
    marque: 'Brand:',
    mois: 'Month:',
    reco: 'Reco:',
    audience: 'Audience:',
    territoire: 'Territory:',
    toutes: 'All',
    tous: 'All',
    priorite: 'Priority',
    considerer: 'Consider',
    radar: 'Radar',
    coeur: 'Core',
    adjacent: 'Adjacent',
    horsCible: 'Off target',
  },
  selectionnes: 'selected this session',
  colonne: {
    mois: 'Month',
    date: 'Date / window',
    evenement: 'Event',
    categorie: 'Category',
    audience: 'Audience',
    pourquoi: 'Why it matters',
    prediction: 'Media projection',
    opportunite: 'Opportunity',
    format: 'Format',
    territoire: 'Territory',
    reco: 'Reco',
  },
  aideSelection: 'Select for the shared session',
  legende: {
    lecture: '· Confirmed = fixed date · Window = likely period · TBC = may move (re-check at D-60)',
  },
  grille: {
    moments: 'Key moments',
    calme: 'nothing notable: a quiet month.',
    fenetre: 'window · {nom} - {date}',
  },
}
